import store from 'src/config/store';
import { resolveDatafields } from 'src/features/dataConnector';
import { REQUEST_UPDATE_PLAYLIST_GRAPHIC } from 'src/redux/reducers/playlistGraphic';

import type { AutoUpdateDataListener } from './autoUpdateManager';

const playlistGraphicAutoUpdateListener: AutoUpdateDataListener = async ({
  playlistGraphicId,
  rawData,
  config,
}) => {
  try {
    const state = store.getState();
    const playlistGraphicState = state.playlistGraphic;

    const playlistGraphic = playlistGraphicState.playlistGraphics?.find(
      (graphic) => graphic.id === playlistGraphicId
    );

    if (!playlistGraphic) {
      return;
    }

    const resolved = await resolveDatafields({
      properties: playlistGraphic.graphic.properties,
      data: rawData,
    });

    if (Object.keys(resolved.errors).length > 0) {
      console.error('Property resolution errors:', resolved.errors);
    }

    const updatedGraphic: PlaylistGraphic = {
      ...playlistGraphic,
      propertiesValues: {
        ...playlistGraphic.propertiesValues,
        ...resolved.propertyValues,
      },
    };

    store.dispatch({
      type: REQUEST_UPDATE_PLAYLIST_GRAPHIC,
      payload: {
        graphic: updatedGraphic,
        updateLive: config.pushWhenOnAir,
      },
    });
  } catch (err) {
    console.error('Failed to apply auto-update data to playlist graphic', err);
  }
};

export const getPlaylistGraphicAutoUpdateListener = () => playlistGraphicAutoUpdateListener;
